import React from 'react';
import Box, { BoxProps } from 'ui-box';
import { defaultFills } from '../npaper';

export const Logo: React.FC<BoxProps<'svg'>> = (props) => (
  <Box
    is="svg"
    width={40}
    height={40}
    viewBox="0 0 40 40"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g fill={defaultFills.brand[500]} fillRule="evenodd">
      <path d="M32 0v32H0c7.733-2.933 14.267-7.067 19.6-12.4C24.933 14.267 29.067 7.733 32 0zM8 36h24v4H8z" />
    </g>
  </Box>
);
